import { iconDictionary } from '~/utils/icon-dictionary'

export function getIcon(key) {
  const iconName = iconDictionary.get(key)

  return iconName ? require(`~/assets/images/${iconName}?inline`) : null
}
